export const getFiscalFullName = (fiscalType: string) => {
  return {
    label: {
      eng: 'Company name*',
      rus: 'Название компании*',
      kz: 'Толық аты*',
    },
    placeholder: {
      eng: `${
        '«London industrial company»'
      }`,
      rus: `${
        '«Московская промышленная компания»'
      }`,
      kz: `${
        '«Мәскеу өнеркәсіптік компаниясы»'
      }`,
    },
  }
}
